import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FaqsComponent } from './faqs/faqs.component';
import { SupportHomeComponent } from './support-home/support-home.component';
import { RouterModule } from '@angular/router';
import { routing } from './support.routing';
import { AppComponent } from '../app.component';
import { AuthGuard } from '../auth.guard';
import { SharedModule } from '../shared/modules/shared.module';
import { FaqListComponent } from './faq-list/faq-list.component';
import { FaqEditComponent } from './faq-edit/faq-edit.component';
import { SupportService } from './services/support.service';
import { FormsModule } from '@angular/forms';
import { QuillModule } from 'ngx-quill';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ReleaseHistoryComponent } from './release-history/release-history.component';
import { ReleaseNotesComponent } from './release-notes/release-notes.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule.forRoot(routing, {}),
    SharedModule,
    QuillModule,
    DragDropModule,
  ],
  declarations: [SupportHomeComponent, FaqsComponent, FaqEditComponent, FaqListComponent,
                ReleaseHistoryComponent, ReleaseNotesComponent],
  exports: [],
  providers: [AppComponent, AuthGuard, SupportService]
})
export class SupportModule { }
